export enum AboutFeatureId {
  INVENTORY = "inventory",
  ORDERS = "orders",
  STORES = "stores",
  INSIGHTS = "insights",
  APPS = "apps"
}
